import React from 'react';
import { SvyIcon } from '@innovorder/savory';
import { FollowUpStatus } from 'services/order/order.type';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@emotion/react';
import { BannerContainer, StatusText, Spacer, getStatusStyle } from './StatusBanner.style';

interface StatusBannerProps {
    status?: FollowUpStatus;
    onClick: () => void;
}

const StatusBanner: React.FC<StatusBannerProps> = ({ status, onClick }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    if (!status) return null;
    const statusKey = `ticket_status_${status.toLowerCase()}` as const;
    const statusText = t(statusKey as import('locales/fr').TranslationKey) || status;
    const style = getStatusStyle(status, theme);
    return (
        <BannerContainer
            style={style}
            onClick={onClick}
            data-testid="order-status-banner"
            role="button"
            tabIndex={0}
            aria-label={statusText}
        >
            <SvyIcon icon={style.icon} style={{ color: style.color, marginRight: 12 }} />
            <StatusText color={style.color}>{statusText}</StatusText>
            <Spacer />
            <SvyIcon icon="arrow-right-s-line" style={{ color: style.chevron }} />
        </BannerContainer>
    );
};

export default StatusBanner;
